// extracted by mini-css-extract-plugin
export default {"scroll_up_button":"ScrollUpButton_scroll_up_button__3PmcD"};